import { FC } from 'react';

import { InputMod } from '@enums';
import type { MultipleSelectInputProps } from '@types';

import { BaseMultipleSelectInput, FilledMultipleSelectInput } from '.';

export const MultipleSelectInput: FC<MultipleSelectInputProps> = ({ inputMod, ...props }) => {
  const isFilled = inputMod === InputMod.Filled;

  return isFilled ? (
    <FilledMultipleSelectInput inputMod={inputMod} {...props} />
  ) : (
    <BaseMultipleSelectInput {...props} />
  );
};
